/**
 * @generated SignedSource<<e96bd46be0598c1fbd56b8fb04786fc9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "removeVibePost",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "sharedPost",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharedByCurrentUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "quotedPost",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quotesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quotedByCurrentUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentedByCurrentUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postMenuRemovePostMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postMenuRemovePostMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1b83655c36bcff7555498c6d6b830ee5",
    "id": null,
    "metadata": {},
    "name": "postMenuRemovePostMutation",
    "operationKind": "mutation",
    "text": "mutation postMenuRemovePostMutation(\n  $request: RemoveVibePostRequestInput!\n) {\n  removeVibePost(request: $request) {\n    id\n    removed\n    sharedPost {\n      id\n      sharesCount\n      sharedByCurrentUser\n    }\n    quotedPost {\n      id\n      quotesCount\n      quotedByCurrentUser\n    }\n    parent {\n      id\n      commentsCount\n      commentedByCurrentUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "5a9791df8889bad068ad1048632a7597";

module.exports = node;
